import React, { useEffect, useRef } from "react";
import { ColorRing, RotatingLines } from "react-loader-spinner";

const SmallLoader = ({ color }) => {
  return (
    <div className="mx-3">
      <ColorRing
        visible={true}
        height="30"
        width="30"
        ariaLabel="color-ring-loading"
        wrapperStyle={{}}
        wrapperClass="color-ring-wrapper"
        colors={['#fff', '#fff', '#fff', '#fff', '#fff']}
      />
    </div>
  );
};

export default SmallLoader;
